import { render, staticRenderFns } from "./huotiOrderList.vue?vue&type=template&id=42c759f3&scoped=true&"
import script from "./huotiOrderList.vue?vue&type=script&lang=js&"
export * from "./huotiOrderList.vue?vue&type=script&lang=js&"
import style0 from "./huotiOrderList.vue?vue&type=style&index=0&id=42c759f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c759f3",
  null
  
)

export default component.exports